import React from "react";
import { ProgressBar } from "react-bootstrap";

const ManageStatusBar = ({ step, status }) => {
  
  return (
    <div style={{ width: "100%" }}>
      {step && (
        <div className="progressbar-datanewcard">
          <ProgressBar
            className={1 === parseInt(step) ? "runing" : ""}
            variant={
              status.toLowerCase() === "failed" && parseInt(step) === 1
                ? "danger"
                : "success"
            }
            now={parseInt(step) >= 1 ? 100 : 0}
            style={{ width: "10%" }}
            key={1}
          />

          <ProgressBar
            className={2 === parseInt(step) ? "runing" : ""}
            variant={
              status.toLowerCase() === "failed" && parseInt(step) === 2
                ? "danger"
                : "success"
            }
            now={parseInt(step) >= 2 ? 100 : 0}
            style={{ width: "10%" }}
            key={2}
          />

          <ProgressBar
            className={3 === parseInt(step) ? "runing" : ""}
            variant={
              status.toLowerCase() === "failed" && parseInt(step) === 3
                ? "danger"
                : "success"
            }
            now={parseInt(step) >= 3 ? 100 : 0}
            style={{ width: "60%" }}
            key={3}
          />

          <ProgressBar
            className={4 === parseInt(step) ? "runing" : ""}
            variant={
              status.toLowerCase() === "failed" && parseInt(step) === 4
                ? "danger"
                : "success"
            }
            now={parseInt(step) >= 4 ? 100 : 0}
            style={{ width: "10%" }}
            key={4}
          />

          <ProgressBar
            className={5 === parseInt(step) ? "runing" : ""}
            variant={
              status.toLowerCase() === "failed" && parseInt(step) === 5
                ? "danger"
                : "success"
            }
            now={parseInt(step) >= 5 ? 100 : 0}
            style={{ width: "10%" }}
            key={5}
          />
        </div>
      )}
    </div>
  );
};

export default ManageStatusBar;
